(function () {
  let scrollTarget = window.scrollY;
  let isScrolling = false;
  let scrollResetTimer = null;

  window.addEventListener('wheel', function (e) {
    // 対象がスクロール可能な内部要素なら処理しない
    if (hasScrollableParent(e.target)) return;

    e.preventDefault();

    scrollTarget += e.deltaY * 1.5;
    scrollTarget = Math.max(0, Math.min(scrollTarget, document.body.scrollHeight - window.innerHeight));

    // スクロール処理中でなければ開始
    if (!isScrolling) {
      requestAnimationFrame(smoothScroll);
      isScrolling = true;
    }

    // スクロールターゲットのリセットタイマー（後述）
    if (scrollResetTimer) clearTimeout(scrollResetTimer);
    scrollResetTimer = setTimeout(() => {
      scrollTarget = window.scrollY;
    }, 500); // ← スクロール終了後、500msでリセット
  }, { passive: false });

  // スムーズスクロール本体
  function smoothScroll() {
    const currentScroll = window.scrollY;
    const distance = scrollTarget - currentScroll;
    const scrollStep = distance * 0.05;

    if (Math.abs(distance) > 0.5) {
      window.scrollTo(0, currentScroll + scrollStep);
      requestAnimationFrame(smoothScroll);
    } else {
      window.scrollTo(0, scrollTarget);
      isScrolling = false;
    }
  }

  // スクロール可能な親要素を判定
  function hasScrollableParent(el) {
    while (el && el !== document.body) {
      const style = getComputedStyle(el);
      const overflowY = style.overflowY;
      const canScroll = (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
      if (canScroll) return true;
      el = el.parentElement;
    }
    return false;
  }
})();
